import * as React from "react";

function ThreeDots(props) {
  const { color = "#606060" } = props; 

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="4" viewBox="0 0 20 4" style={{ ...props.style }}>
      <g transform="translate(-262 -108)">
        <g transform="translate(2 -1.129)">
          <circle cx="2" cy="2" r="2" transform="translate(276 109.129)" fill={color} />
        </g>
        <g transform="translate(-7 -2.129)">
          <circle cx="2" cy="2" r="2" transform="translate(277 110.129)" fill={color} />
        </g>
        <g transform="translate(-15 -2.129)">
          <circle cx="2" cy="2" r="2" transform="translate(277 110.129)" fill={color} />
        </g>
      </g>
    </svg>
  );
}

export default ThreeDots;
